const VERSION = '3.8.6';
export default VERSION;
